import { Component } from '@angular/core';

@Component({
  selector: 'app-student-hostel',
  imports: [],
  templateUrl: './student-hostel.component.html',
  styleUrl: './student-hostel.component.scss'
})
export class StudentHostelComponent {

}
